export default __webpack_public_path__ + "static/media/usdt-logo.66d271aa.svg";